import { IMaterialDetail } from "@/services/createSpace/graphQ/getSimpleMedia";
import {
  IBgResponse,
  ICoverItemResponse,
  IDecorationsItemResponse,
  IMusicResponse,
} from "@/services/mixCutDetail/mixCutDetail";
import mixCutDetailStore from "@/stores/mixCutDetailStore";
import useMixCutDetailSave from "@/useStore/quickCut/useMixCutDetailSave";
import { toJS } from "mobx";
import ConfigStore from '@/stores/mixedConfig/index'
import QuickCutStore from "@/stores/quickCutStore/index";
import usePreviewConfig from "@/useStore/preview/usePreview";
interface IUseCoverAndBgReturn {
  cover: ICoverItemResponse[];
  decorations: IDecorationsItemResponse[];
  bgColor: string;
  bgAudio: IMusicResponse[];
  bgImages: (IBgResponse | IMaterialDetail)[];
  bgAudioVolumn: number;
  handleCoverChange: (cover: ICoverItemResponse[]) => void;
  handleBgChange: (bgColor: string) => void;
  handleBgAudiosChange: (bgAudios: IMusicResponse[]) => void;
  handleBgImagesChange: (images: (IBgResponse | IMaterialDetail)[]) => void;
  handleBgAudioVolumn: (volumn: number) => void;
  handleDecorationChange: (decoration) => void;
}

const useCoverAndBg = (): IUseCoverAndBgReturn => {
  const { handleSaveMixCutDetailSave } = useMixCutDetailSave();
  const { handleClipIdChange, handlePreviewDecorationChange } = usePreviewConfig();
  const handleBgAudiosChange = (bgAudios: IMusicResponse[]) => {
    const bgMusic = bgAudios.map(item => {
      return {
        ...item,
        url: item.url ? item.url : item.file_url
      }
    })
    mixCutDetailStore.setProjectBgAudio(bgMusic);
    QuickCutStore.quickcutData.settings.background.musics = bgMusic;
    handleSaveMixCutDetailSave();
  };

  const handleBgChange = (bgColor: string) => {
    mixCutDetailStore.setProjectBgColor(bgColor);
    ConfigStore.global_settings.background.color = bgColor;
    handleSaveMixCutDetailSave();
  };
  const handleBgImagesChange = (images: IBgResponse[]) => {
    mixCutDetailStore.setProjectBgImages(images);
    ConfigStore.global_settings.background.images = images;
    handleSaveMixCutDetailSave();
  };

  const handleCoverChange = (newCover: ICoverItemResponse[]) => {
    mixCutDetailStore.setProjectCover(newCover);
    ConfigStore.global_settings.cover = newCover;
    handleSaveMixCutDetailSave();
  };
  // 装饰图修改
  const handleDecorationChange = (newDecoration) => {
    ConfigStore.global_settings.decorations = newDecoration;
    if (newDecoration && newDecoration.length > 0) {
      handlePreviewDecorationChange(newDecoration)
      handleSaveMixCutDetailSave();
    } else {
      handlePreviewDecorationChange([])
      handleSaveMixCutDetailSave();
    }
  };

  const handleBgAudioVolumn = (volumn: number) => {
    mixCutDetailStore.setProjectBgAudioVolum(volumn);
    QuickCutStore.quickcutData.settings.background.music_volume = volumn;
    handleSaveMixCutDetailSave();
  };

  return {
    bgAudioVolumn: QuickCutStore.quickcutData.settings.background.music_volume,
    cover: ConfigStore.global_settings.cover,
    bgColor: ConfigStore.global_settings.background.color,
    bgAudio: QuickCutStore.quickcutData.settings.background.musics,
    bgImages: ConfigStore.global_settings.background.images,
    decorations: ConfigStore.global_settings.decorations, // 装饰图
    handleBgAudioVolumn,
    handleCoverChange,
    handleDecorationChange,
    handleBgChange,
    handleBgAudiosChange,
    handleBgImagesChange,
  };
};

export default useCoverAndBg;
